export const absoluteURL = (url) => {
    return process.env.PUBLIC_URL + url
}

// Return only digits from the provided phone string. Removes spaces, '+', and all non-digits.
export const sanitizePhoneDigitsOnly = (phone) => {
    const raw = phone == null ? "" : String(phone)
    return raw.replace(/\D+/g, "")
}

export const getMagicLinkUrl = (bookingId, hash, envType = process.env.REACT_APP_ENV) => {
    const domain =
        String(envType || "prod").toLowerCase() === "prod"
            ? "ss.stayflexi.com"
            : String(envType || "").toLowerCase() === "beta"
            ? "beta-next.selfservice.stayflexi.com"
            : "preprod-next.selfservice.stayflexi.com";

    const extractedBookingId = String(bookingId ?? "").split("_");
    if (extractedBookingId.length > 2) {
        return `https://${domain}/${extractedBookingId[1]}${extractedBookingId[2]}/${hash}`;
    }
    console.warn("Need to check the split of extractedBookingId", extractedBookingId);
    return ``;
};

export const toLowercaseName = (name) => {
    const raw = name == null ? "" : String(name)
    return raw.trim().toLowerCase()
}